angular.module('app.controllers.contractor_referral', [])

  .controller('ContractorReferralController', ['$rootScope','$scope','$log','$location','$window', function ($rootScope, $scope, $log, $location, $window) {
    'use strict';

    $log.debug('ContractorReferralController()');

    $scope.windowWidth = function () {
      return $window.innerWidth;
    };

  }]);

